export const autochargeEn = {
  EVERY: 'Every',
}

export const autochargeEs: typeof autochargeEn = {
  EVERY: 'Cada',
}
